export default __webpack_public_path__ + "static/education_b.d84c582886cac8ae5b528e959c756aa8.png";